import { AfterViewInit, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { select, Store } from '@ngrx/store';
import WIDGED_SEND_MESSAGE_TYPES from '../../../../old-crazy-web-frontend/src/app/utils/widget.send.message.types';
import { getAuthTokenSelector } from '../auth/auth.reducer';
import { environment } from '../../../environments/environment';
import { WebWidgetService } from './web-widget.service';
import { AccountService } from '../services/account.service';
import { combineLatest, Subject } from 'rxjs';
import { distinctUntilChanged, withLatestFrom } from 'rxjs/operators';
import { getUserDetailsSelector } from '../user/user.reducer';
import { getUsersSelector } from '../../users/users.reducer';
import { GetCurrentUserAction, GetUsersAction } from '../../users/users.action';
import { NgxPermissionsService } from "ngx-permissions";
var WebWidgetComponent = /** @class */ (function () {
    function WebWidgetComponent(store, sanitizer, webWidgetService, accountService, ngxPermissionsService) {
        this.store = store;
        this.sanitizer = sanitizer;
        this.webWidgetService = webWidgetService;
        this.accountService = accountService;
        this.ngxPermissionsService = ngxPermissionsService;
        this.isOpened = false;
        this.isBlockIncomingCallsState = false;
        this.didUserInteractedWithPage = false;
        this.clickAnywhere$ = new Subject();
        this.webWidgetUrl = this.sanitizer.bypassSecurityTrustResourceUrl(environment.WEB_WIDGET_URL);
    }
    WebWidgetComponent.prototype.documentClick = function (event) {
        this.clickAnywhere$.next(true);
        this.didUserInteractedWithPage = true;
    };
    WebWidgetComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.ngxPermissionsService.hasPermission('EDIT_USER_PERMISSION').then(function (result) {
            if (result) {
                _this.store.dispatch(new GetUsersAction());
            }
            else {
                _this.store.dispatch(new GetCurrentUserAction());
            }
        });
        this.userDetails$ = this.store.select(getUserDetailsSelector);
        this.users$ = this.store.select(getUsersSelector);
        combineLatest([this.userDetails$, this.users$]).subscribe(function (_a) {
            var user = _a[0], users = _a[1];
            _this.currentUserId = user.id;
            if (users.length) {
                _this.isBlockIncomingCallsState = users.find(function (userDetails) { return userDetails.id === user.id; }).doNotAcceptIncomingCalls;
            }
        });
    };
    WebWidgetComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        if (!this.iframe) {
            return;
        }
        this.webWidgetService.iframe = this.iframe.nativeElement;
        this.webWidgetService.listenForEventsInIframe().subscribe(function (event) {
            if (event.data && event.data.type === 'SET_BLOCK_INCOMING_CALLS') {
                _this.isBlockIncomingCallsState = event.data.payload.blocked;
                // this.store.dispatch( new SetBlockIncomingCalls({blocked: event.data.payload.blocked, id: this.currentUserId}))
            }
            else if (event.data && event.data.type === 'INCOMING_CALL') {
                _this.isOpened = true;
                _this.handleIncomingCallNotification(event.data.payload.msisdn);
            }
            else if (event.data && event.data.type === 'GET_URL') {
                _this.webWidgetService.sendEventIntoIframe(Object.assign(WIDGED_SEND_MESSAGE_TYPES.SEND_URL, { url: window.location.href }));
            }
        });
        this.webWidgetService.openIframe$.subscribe(function () {
            _this.isOpened = true;
        });
    };
    WebWidgetComponent.prototype.handleIframeLoaded = function () {
        var _this = this;
        this.accountService.getAccountConfig().subscribe(function (conf) {
            var isFullyConfigured = conf.data;
            if (isFullyConfigured) {
                _this.getDataAndSendToken();
            }
            else {
                _this.accountService.configChanged.subscribe(function (isConfigured) {
                    isFullyConfigured = isConfigured;
                    if (isFullyConfigured) {
                        _this.getDataAndSendToken();
                    }
                });
            }
        });
    };
    WebWidgetComponent.prototype.getDataAndSendToken = function () {
        var _this = this;
        this.store
            .pipe(select(getAuthTokenSelector), withLatestFrom(this.store.pipe(select(getUserDetailsSelector))))
            .subscribe(function (_a) {
            var token = _a[0], user = _a[1];
            if (_this.didUserInteractedWithPage) {
                _this.webWidgetService.sendEventIntoIframe(Object.assign(WIDGED_SEND_MESSAGE_TYPES.SEND_TOKEN, { token: token, domain: user.domain }));
            }
            else {
                _this.clickAnywhere$.pipe(distinctUntilChanged()).subscribe(function () {
                    _this.webWidgetService.sendEventIntoIframe(Object.assign(WIDGED_SEND_MESSAGE_TYPES.SEND_TOKEN, { token: token, domain: user.domain }));
                });
            }
        });
    };
    WebWidgetComponent.prototype.handleIncomingCallNotification = function (msisdn) {
        var _this = this;
        if (!('Notification' in window)) {
            console.log('Notifications not supported in the browser');
        }
        else if (Notification['permission'] === 'granted') {
            this.createBrowserNotification('Incoming call', msisdn);
        }
        else if (Notification['permission'] !== 'denied') {
            Notification.requestPermission().then(function (permission) {
                if (permission === 'granted') {
                    _this.createBrowserNotification('Incoming call', msisdn);
                }
            });
        }
    };
    WebWidgetComponent.prototype.openWidget = function () {
        this.isOpened = !this.isOpened;
        this.requestNotifications();
    };
    WebWidgetComponent.prototype.requestNotifications = function () {
        if (!('Notification' in window)) {
            console.log('Notifications not supported in the browser');
        }
        else if (Notification['permission'] === 'granted') {
            return;
        }
        else if (Notification['permission'] !== 'denied') {
            Notification.requestPermission().then(function (permission) {
                console.log("Notifications state: " + permission);
            });
        }
    };
    WebWidgetComponent.prototype.createBrowserNotification = function (title, body) {
        var notification = new Notification(title, {
            body: body
        });
        notification.onclick = function () {
            window.focus();
        };
    };
    WebWidgetComponent.prototype.handleClickOutside = function (event) {
        this.isOpened = false;
    };
    return WebWidgetComponent;
}());
export { WebWidgetComponent };
